// Cheer Notifications: dashboard badge when a new grandparent cheer arrives.
import { useEffect, useState } from "react";
import { PartyPopper, X } from "lucide-react";
import { api } from "../../lib/api";

export const CheerBadge = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/math-mastery/cheers/unseen")
      .then(({ data: d }) => d.count > 0 && setData(d)).catch(() => {});
  }, []);

  if (!data) return null;
  const dismiss = () => {
    setData(null);
    api.post("/math-mastery/cheers/seen").catch(() => {});
  };
  return (
    <div className="bg-emerald-50 border-2 border-emerald-300 rounded-2xl p-4 flex items-start gap-3"
      data-testid="cheer-badge">
      <PartyPopper className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" aria-hidden="true" />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-extrabold font-display">
          {data.count} new cheer{data.count > 1 ? "s" : ""} arrived!
        </p>
        {data.latest.map((c, i) => (
          <p key={i} className="text-xs text-muted-foreground truncate" data-testid={`cheer-badge-note-${i}`}>
            <span className="font-bold">{c.author}</span> cheered {c.child_name}: "{c.text}"
          </p>
        ))}
      </div>
      <button type="button" onClick={dismiss} aria-label="Mark cheers as seen"
        className="rounded-full p-1.5 hover:bg-emerald-100" data-testid="cheer-badge-dismiss">
        <X className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
};
